import type { Config as MixpanelConfig } from 'mixpanel-browser';
import { mixpanelService } from '~/core/service/mixpanel/mixpanel';
import { version } from '~~/package.json';

export default defineNuxtPlugin({
	name: 'mixpanel',
	async setup() {
		const MIXPANEL_INSTANCE_KEY = 'mixpanel-instance';
		const runtimeConfig = useRuntimeConfig();
		const mixpanelEnv = runtimeConfig.public.mixpanel;

		const token = mixpanelEnv.token as string;
		const debug = mixpanelEnv.debug as boolean;
		const proxyUrl = (mixpanelEnv.proxy_url as string) || undefined;

		const { user } = useUserSession();

		const mixpanelConfig: Partial<MixpanelConfig> = {
			track_pageview: true,
			debug,
			api_host: proxyUrl
		};
		const mixpanel = mixpanelService(
			token,
			mixpanelConfig,
			MIXPANEL_INSTANCE_KEY,
			version
		);

		mixpanel.init();
		mixpanel.config(user.value);

		return {
			provide: {
				mixpanel
			}
		};
	}
});
